import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { ParsedFormSignatureCertificateModel } from '../../models';
import { CollapsibleComponent } from '../CollapsibleComponent';
import * as DateFNS from "date-fns";

export const ModalMessageShowSignature: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.stat;

		if (!dataState.Statement?.Form?.Certificate)
		{
			return (
				<div className="modal-content">
					<p className="mb-0">Подпись не существует</p>
				</div>
			);
		}

		let cert = new ParsedFormSignatureCertificateModel(dataState.Statement.Form.Certificate);
		let signDateString: string = "";
		if (dataState.Statement.Form.SignatureDate)
		{
			let signDate = DateFNS.parseISO(dataState.Statement.Form.SignatureDate);
			if (DateFNS.isValid(signDate)) signDateString = DateFNS.format(signDate, "dd.MM.yyyy HH:mm");
		}

		return (
			<>
				<div className="modal-content">
					<div className="choose-sertificate">
						<div className="sertificate">
							<div className="sertificate-block">
								<div className="row mb-1">
									<div className="col-md-3"><p className="mb-0 title">Владелец:</p></div>
									<div className="col-md-9"><p className="mb-0 def">{store.GetSubject(cert.Subject)}</p></div>
								</div>
								<div className="row mb-1">
									<div className="col-md-3"><p className="mb-0 title">Организация:</p></div>
									<div className="col-md-9"><p className="mb-0 def">{cert.Subject.get("O")}</p></div>
								</div>
								<div className="row mb-1">
									<div className="col-md-3"><p className="mb-0 title">Номер сертификата:</p></div>
									<div className="col-md-9"><p className="mb-0 def break-word">{cert.SerialNumber}</p></div>
								</div>
								<div className="row mb-1">
									<div className="col-md-3"><p className="mb-0 title">Период действия:</p></div>
									<div className="col-md-9"><p className="mb-0 def">{DateFNS.format(cert.ValidFromDate, "dd.MM.yyyy")} - {DateFNS.format(cert.ValidToDate,"dd.MM.yyyy")}</p></div>
								</div>
								<div className="row mb-1">
									<div className="col-md-3"><p className="mb-0 title">Кем выдан сертификат:</p></div>
									<div className="col-md-9"><p className="mb-0 def">{store.GetSubject(cert.Issuer)}</p></div>
								</div>
								<div className="row">
									<div className="col-md-3"><p className="mb-0 title">Дата подписания:</p></div>
									<div className="col-md-9"><p className="mb-0 def">{signDateString}</p></div>
								</div>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-center mt-4">
						<div className="accordions-container">
							<CollapsibleComponent IsRequired={false} HeaderText="Электронная подпись" ErrorText="" ID="4A6911AB1DE24E70BC4B470A07150C5F" IsCompleted={false} IsValidated={false}>
								<div className="accordion-content">
									<div className="key-container pr-3">
										<p className="mb-0 break-word">{dataState.Statement.Form.Signature}</p>
									</div>
								</div>
							</CollapsibleComponent>
						</div>
						<div>
							<a download="Заявление_оператора_ЭДО.sgn" href={dataState.GetSgnFileLink()} className="btn btnIco download ml-3" target="_blank" rel="noopener noreferrer nofollow">
								Скачать
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M12.023 2.75C12.5753 2.75 13.023 3.19772 13.023 3.75V14.8248L15.5396 12.2951C15.9292 11.9036 16.5623 11.902 16.9539 12.2915C17.3454 12.681 17.347 13.3142 16.9575 13.7057L12.73 17.9551C12.3406 18.3466 11.7075 18.3482 11.3159 17.9588L7.0434 13.7095C6.65181 13.32 6.65009 12.6868 7.03955 12.2952C7.42901 11.9037 8.06218 11.9019 8.45376 12.2914L11.023 14.8467V3.75C11.023 3.19772 11.4707 2.75 12.023 2.75ZM3.25 15.4189C3.25 14.8667 2.80228 14.4189 2.25 14.4189C1.69772 14.4189 1.25 14.8667 1.25 15.4189V18.565C1.25 20.2219 2.59315 21.565 4.25 21.565H19.7592C21.4161 21.565 22.7592 20.2219 22.7592 18.565V15.4189C22.7592 14.8667 22.3115 14.4189 21.7592 14.4189C21.2069 14.4189 20.7592 14.8667 20.7592 15.4189V18.565C20.7592 19.1173 20.3115 19.565 19.7592 19.565H4.25C3.69772 19.565 3.25 19.1173 3.25 18.565V15.4189Z" fill="black" />
								</svg>
							</a>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="d-flex align-items-center">
						<button
							className="btn btn-primary ml-auto"
							onClick={() => { uiState.modal.setShowModal(false); }}
						>Закрыть</button>
					</div>
				</div>
			</>
		);
	}
)
